<template>
  <div class="wallet-layout">
    <HeadTop @search="search" :enableSearch="true" />
    <div class="wallet-content">
      <div class="wallet-inner">
        <router-view :searchKeyword="searchKeyword" />
      </div>
    </div>
  </div>
</template>

<script>
import HeadTop from '@/components/base/head.vue'

export default {
  name: 'WalletLayout',
  components: {
    HeadTop
  },
  data() {
    return {
      wallet: {},
      info: {},
      searchKeyword: ''
    }
  },
  created() {
    //this.getInfo()
    //this.getWallet()
  },
  methods: {
    search(val) {
      // console.log(val)
      this.searchKeyword = val // 更新搜索关键词
    },
    getInfo() {
      this.info = this.$common.getInfo() || {}
    },
    getWallet() {
      const hide = this.$message.loading({ content: 'loading...', key: 'msg' })
      this.$api.userWallet
        .getWallet()
        .then((res) => {
          hide()
          if (res.data) {
            this.wallet = res.data
          } else {
            this.$message.error('获取钱包信息失败')
          }
        })
        .catch(() => {
          hide()
          this.$message.error('获取钱包信息失败')
        })
    }
  }
}
</script>

<style scoped>
/* ============================================================
   钱包布局 - 暗色主题
   ============================================================ */

.wallet-layout {
  min-height: 100vh;
  background: #0b0d0f;
}

/* ============================================================
   内容区域
   ============================================================ */
.wallet-content {
  background: #131313;
  min-height: calc(100vh - 64px);
  padding: 0;
}

.wallet-inner {
  max-width: 1440px;
  margin: 0 auto;
  padding: 20px 24px 40px;
}

/* ============================================================
   子组件样式穿透（确保所有子组件适配暗色）
   ============================================================ */
.wallet-inner :deep(.deposit-container),
.wallet-inner :deep(.finance-container),
.wallet-inner :deep(.address-container),
.wallet-inner :deep(.jyjl-container),
.wallet-inner :deep(.withdrawal-container),
.wallet-inner :deep(.bank-transfer-container) {
  background: transparent;
  color: #e8edf2;
}

/* ============================================================
   响应式
   ============================================================ */
@media (max-width: 768px) {
  .wallet-inner {
    padding: 12px 12px 30px;
  }
}

@media (max-width: 480px) {
  .wallet-inner {
    padding: 8px 8px 20px;
  }
}
</style>
